import type { ReactNode } from "react";
import { Button } from "@mui/material";
import ConfirmDialog from "../confirm-dialog";

// ----------------------------------------------------------------------

export type DiscardFormDialogProps = {
  open: boolean;
  onClose: () => void;
  onDiscard: () => void;
  title?: string;
  content?: ReactNode;
};

const DEFAULT_TITLE = "Discard form?";
const DEFAULT_CONTENT = (
  <>It will erase all the data you entered. Do you want to continue?</>
);

export default function DiscardFormDialog({
  open,
  onClose,
  onDiscard,
  title = DEFAULT_TITLE,
  content = DEFAULT_CONTENT,
}: DiscardFormDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      title={title}
      content={content}
      action={
        <Button variant="contained" color="error" onClick={onDiscard}>
          Yes
        </Button>
      }
    />
  );
}
